import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import CustomerService from '@/services/CustomersServices/CustomerService';
import { extractError } from '@/helpers/extractApiError';

const model = {
    data: null,
    submitting: false,
    errors: null,
    loading: false,
};

export const getCustomerProjectList = createAsyncThunk(
    'customer/getCustomerProjectList',
    async (data, { rejectWithValue }) => {
        try {
            const response = await CustomerService.getCustomerProjectList(data, data.customer_id);
            return response.data.map((project) => ({
                ...project,
                originalSubmissions: project.submissions,
            }));
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    },
);

const viewCustomerSlice = createSlice({
    name: 'getCustomerProjectList',
    initialState: model,
    reducers: {
        filterSubmittals: (state, action) => {
            const {
                status: statusFilter,
                date: dateFilter,
                project_id: projectId,
            } = action.payload;
            const project = state.data.find((item) => item.id === projectId);
            project.submissions = [...project.originalSubmissions];
            if (statusFilter && dateFilter) {
                project.submissions = project.submissions.filter(
                    (submission) => submission.quote_requested === statusFilter
                        && new Date(submission.created_date || submission.quote_requested_date).toISOString().split('T')[0] === dateFilter,
                );
            } else if (statusFilter) {
                const status = statusFilter === '1';
                project.submissions = project.submissions.filter(
                    (submission) => submission.quote_requested === status,
                );
            } else if (dateFilter) {
                project.submissions = project.submissions.filter((submission) => new Date(submission.created_date || submission.quote_requested_date).toISOString().split('T')[0] === dateFilter);
            } else {
                project.submissions = project.originalSubmissions;
            }
        },
    },
    extraReducers: (builder) => {
        // get customer project list
        builder.addCase(getCustomerProjectList.pending, (state) => {
            state.loading = true;
        }).addCase(getCustomerProjectList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        }).addCase(getCustomerProjectList.rejected, (state, action) => {
            state.loading = false;
            state.errors = action.payload;
        });
    },
});

export const { filterSubmittals } = viewCustomerSlice.actions;

export default viewCustomerSlice.reducer;
